// Export types
export * from "./types/communication";
export * from "./types/dimensions";
export * from "./types/ml-extraction";

// Export services
export * from "./services/ApiService";
export * from "./services/ArchetypeService";
export * from "./services/CacheService";
export * from "./services/ClassificationService";
export * from "./services/ComprehendService";
export * from "./services/DimensionExtractor";
export * from "./services/DimensionExtractionIntegrator";
export * from "./services/DimensionMapper";
export * from "./services/EntityExtractor";
export * from "./services/IngestionPipeline";
export * from "./services/RelationshipDetector";
export * from "./services/SchemaMigrator";
export * from "./services/SentimentAnalyzer";
export * from "./services/SourceAdapter";
export * from "./services/TopicCategorizer";
export * from "./services/UnifiedDataService";
export * from "./services/UrgencyDetector";

// Export parsers
export * from "./services/parsers/EmailParser";
export * from "./services/parsers/DocumentParser";
export * from "./services/parsers/SocialParser";

// Export adapters
export * from "./services/adapters/EmailAdapter";
export * from "./services/adapters/DocumentAdapter";
export * from "./services/adapters/SocialAdapter";

// Sample data removed for production build
